// Five-digit French postal codes for DROM/COM:
// 971xx Guadeloupe, 972xx Martinique, 973xx Guyane, 974xx La Réunion,
// 976xx Mayotte, 977xx Saint-Barthélemy, 978xx Saint-Martin.
const DROM_POSTAL_REGEX = /^97[12346-8]\d{2}$/;

export function isDromAddress(postalCode: string | null | undefined): boolean {
  if (!postalCode) {
    return false;
  }
  return DROM_POSTAL_REGEX.test(postalCode);
}
